/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Card, CardContent, Grid, Tooltip } from "@mui/material";
import { Cached, Clear, Edit, Info, Search, ArrowBack, Delete } from "@mui/icons-material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortModel, GridSortDirection } from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";

import AutoComplete from "../../../components/hookForms/autoComplete";
import { Container } from "../../../theme/globalStyles";
import DataTable from "../../../components/dataTable";
import DialogEdit from "./modal/dialogEdit";
import DialogSync from "./modal/dialogSync";
import IGenericResult from "../../../interfaces/IGenericResult";
import InputNumber from "../../../components/hookForms/inputNumber";
import InputDocumento from "../../../components/hookForms/inputDocumento";
import TextInput from "../../../components/hookForms/textField";
import messages from "../../../utils/messages";
import serviceClienteInstalacao from "../../../services/serviceClienteInstalacao";
import { toast } from "react-toastify";
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { Divider } from "./styles";
import serviceConcessionaria from "@/services/serviceConcessionaria";
import ConfirmationDialog from "@/components/confirmationDialog";
import DropdownTableEdit from "./dropdown/dropdown";
import DialogTravaFatura from "./modal/dialogTravaFatura";
import DialogRegraDataVencimento from "./modal/dialogRegraDataVencimento";
import DialogDelete from "./modal/dialogDelete";

const ClienteInstalacao = (props: any) => {
    const { setTitlePage } = useAuth();
    const [showBackOptions, setShowBackOptions] = useState(false);

    const filterOld = props?.location?.state?.filterOld || "";
    const rotaAnterior = props?.location?.state?.rotaAnterior || "";
    const { handleGetDataUser } = useAuth();
    const user = handleGetDataUser();
    const isAdmin = user.perfil === "Admin";

    useEffect(() => {
        setTitlePage("Cadastro - Instalações de clientes");
    }, [setTitlePage]);

    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [rowCount, setRowCount] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setLoading] = useState(false);

    const [deleteState, setDeleteState] = useState({
        open: false,
        id: "",
        numeroInstalacao: "",
        nomeCliente: "",
        clienteID: "",
    })

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const [editState, setEditState] = useState({
        open: false,
        id: "",
        nomeCliente: "",
        numeroInstalacao: "",
        regraSaldoReenergisa: "",
        percentualDescontoContratado: "",
        percentualDescontoFaturado: "",
        flagHabilitado: "",
        regraDataVencimento: "",
        dataFixa: null,
    });

    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);
    const [dialogState, setDialogState] = useState(false);
    const [dialogTravaFaturaState, setDialogTravaFaturaState] = useState(false);
    const [tableEditState, setTableEditState] = useState({});
    const [tableEditTravaFaturaState, setTableTravaFaturaEditState] = useState({});
    const [dialogRegraDataVencimentoState, setDialogRegraDataVencimentoState] = useState(false);
    const [dialogRegraDataConfirmState, setDialogRegraDataConfirmState] = useState(false);
    const [tableRegraDataVencimentoState, setTableRegraDataVencimentoState] = useState<any>({});

    const history = useHistory();

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            clienteInstalacaoID: "",
            clienteID: "", //vem por parâmetro quando tela acionada via tela "Clientes"
            nomeCliente: "",
            flagHabilitado: "Sim",
            numeroDocumentoCliente: "",
            numeroInstalacao: "",
            percentualDescontoContratado: "",
            regraSaldoReenergisa: "",
            concessionariaID: "",
            devolucaoImpostos: "",
            travaFatura: "",
            regraDataVencimento: "",
            formaDePagamento: "",
        },
    });

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                minWidth: 160,
                flex: 1,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Revisão de Instalação">
                                <Info />
                            </Tooltip>
                        }
                        label="Revisão de Instalação"
                        onClick={() => {
                            onClickInfo(params.row.clienteInstalacaoID, params.row.numeroInstalacao);
                        }}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Editar">
                                <Edit />
                            </Tooltip>
                        }
                        label="Editar"
                        onClick={() =>
                            setEditState({
                                open: true,
                                id: params.id.toString(),
                                nomeCliente: params.row.nomeCliente,
                                numeroInstalacao: params.row.numeroInstalacao,
                                regraSaldoReenergisa: params.row.regraSaldoReenergisa,
                                percentualDescontoContratado: params.row.percentualDescontoContratado,
                                percentualDescontoFaturado: params.row.percentualDescontoFaturado,
                                flagHabilitado: params.row.flagHabilitado,
                                regraDataVencimento: params.row.regraDataVencimento,
                                dataFixa: params.row.dataFixa,
                            })
                        }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Excluir">
                                <Delete />
                            </Tooltip>
                        }
                        label="Excluir"
                        onClick={() => setDeleteState({
                            open: true,
                            id: params.id.toString(),
                            numeroInstalacao: params.row.numeroInstalacao,
                            nomeCliente: params.row.nomeCliente,
                            clienteID: params.row.clienteID,

                        })}
                        disabled={!isAdmin}


                    />,
                ],
            },
        ],
        []
    );

    const regraDataVencimentoOptions = useMemo(
        () => [
            { label: "Padrão", value: "Padrão" },
            { label: "Co-billing (RE) na Disco", value: "Co-billing (RE) na Disco" },
            { label: "Especial", value: "Especial" },
            { label: "Data fixa", value: "Data fixa" },
            { label: "Co-billing Disco na (RE)", value: "Co-billing Disco na (RE)" },
        ],
        []
    );

    const formaPagamentoOptions = useMemo(
        () => [
            { label: "Boleto", value: "Boleto" },
            { label: "Co-Billing (RE) na Disco", value: "Co-Billing (RE) na Disco" },
            { label: "DCC", value: "DCC" },
            { label: "PIX Automático", value: "PIX Automático" },
        ],
        []
    );

    const handleRegraDataVencimentoChange = (selectedValue: string, instalacaoId: number) => {
        const payload = {
            regraDataVencimento: selectedValue,
            clienteInstalacaoID: instalacaoId,
        };

        setTableRegraDataVencimentoState(payload);

        if (selectedValue === "Data fixa") {
            setDialogRegraDataVencimentoState(true);
        } else {
            setDialogRegraDataConfirmState(true);
        }
    };

    const closeRegraDataConfirmDialog = () => {
        setDialogRegraDataConfirmState(false);
        setTableRegraDataVencimentoState({});
    };

    const handleConfirmRegraDataVencimento = () => {
        if (!tableRegraDataVencimentoState?.regraDataVencimento) {
            closeRegraDataConfirmDialog();
            return;
        }

        onTableEdit({ ...tableRegraDataVencimentoState, dataFixa: null });
        closeRegraDataConfirmDialog();
    };

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "clienteInstalacaoID",
                type: "number",
                headerAlign: "left",
                identity: true,
                minWidth: 100,
                flex: 1,
                id: 70,
            },
            {
                headerName: "Cliente",
                field: "nomeCliente",
                type: "string",
                minWidth: 300,
                flex: 1,
            },
            {
                headerName: "CPF/CNPJ",
                field: "numeroDocumentoClienteFormatado",
                type: "string",
                minWidth: 150,
                flex: 1,
            },
            {
                headerName: "Parceiro",
                field: "nomeParceiro",
                type: "string",
                minWidth: 150,
                flex: 1,
            },
            {
                headerName: "Instalação",
                field: "numeroInstalacao",
                headerAlign: "left",
                type: "number",
                minWidth: 180,
                flex: 1,
            },
            {
                headerName: "Cota (kWp)",
                field: "kwpContratado",
                type: "number",
                headerAlign: "left",
                minWidth: 150,
                flex: 1,
            },
            {
                headerName: "Desconto (%)",
                field: "percentualDescontoContratado",
                type: "number",
                headerAlign: "left",
                minWidth: 150,
                flex: 1,
            },
            {
                headerName: "Desconto Faturamento (%)",
                field: "percentualDescontoFaturado",
                type: "number",
                headerAlign: "left",
                minWidth: 200,
                flex: 1,
            },
            {
                headerName: "Regra saldo Reenergisa",
                field: "regraSaldoReenergisa",
                type: "string",
                minWidth: 210,
                flex: 1,
            },
            {
                headerName: "Forma de pagamento",
                field: "formaDePagamento",
                type: "string",
                minWidth: 200,
                flex: 1,
                sortable: false,
            },
            {
                headerName: "Concessionaria",
                field: "nomeConcessionaria",
                type: "string",
                minWidth: 350,
                flex: 1,
            },
            {
                headerName: "Estado",
                field: "estado",
                headerAlign: "left",
                type: "string",
                minWidth: 80,
                flex: 1,
            },
            {
                headerName: "Grupo",
                field: "grupoLeitura",
                headerAlign: "left",
                type: "string",
                minWidth: 80,
                flex: 1,
            },
            {
                headerName: "Habilitado",
                field: "flagHabilitado",
                type: "string",
                minWidth: 100,
                flex: 1,
            },
            {
                headerName: "Dev. De Impostos",
                field: "devolucaoImpostos",
                type: "string",
                minWidth: 140,
                flex: 1,
                renderCell: (params) => {
                    return (
                        <DropdownTableEdit
                            value={params.value}
                            instalacaoId={params.id}
                            setDialogState={setDialogState}
                            setTableEditState={setTableEditState}
                            propertyName="devolucaoImpostos"
                        />
                    );
                },
            },
            {
                headerName: "Trava De Fat.",
                field: "travaFatura",
                type: "string",
                minWidth: 140,
                flex: 1,
                renderCell: (params) => {
                    return (
                        <DropdownTableEdit
                            value={params.value}
                            instalacaoId={params.id}
                            setDialogState={setDialogTravaFaturaState}
                            setTableEditState={setTableTravaFaturaEditState}
                            propertyName="travaFatura"
                        />
                    );
                },
            },
            {
                headerName: "Observação",
                field: "observacao",
                type: "string",
                minWidth: 300,
                flex: 1,
            },
            {
                headerName: "Regra Data de Vencimento",
                field: "regraDataVencimento",
                type: "string",
                minWidth: 230,
                flex: 1,
                sortable: false,
                renderCell: (params) => {
                    return (
                        <DropdownTableEdit
                            value={params.value}
                            instalacaoId={Number(params.id)}
                            propertyName="regraDataVencimento"
                            options={regraDataVencimentoOptions}
                            onChange={handleRegraDataVencimentoChange}
                            selectWidth={220}
                        />
                    );
                },
            },
            {
                headerName: "Data fixa",
                field: "dataFixa",
                type: "number",
                headerAlign: "left",
                minWidth: 120,
                flex: 1,
                sortable: false,
            },
            {
                headerName: "Nro Campanha",
                field: "numeroCampanhaAtiva",
                type: "number",
                headerAlign: "left",
                minWidth: 140,
                flex: 1,
                sortable: false,
                valueFormatter: ({ value }: any) => (value != null ? value : ""),
            },
            ...actionColumns,
        ],
        [actionColumns, handleRegraDataVencimentoChange, regraDataVencimentoOptions]
    );

    const filtersOptions = [
        { label: "Todos", value: "Todos" },
        { label: "Sim", value: "Sim" },
        { label: "Não", value: "Não" },
    ];

    const handleSync = () => {
        setShowModal(true);
    };

    useEffect(() => {
        setConcessionariaData();
    }, []);

    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(result?.data);
            })
            .catch(() => {
                setConcessionariaDataOptions([]);
            });
    };

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        if (!filters) {
            filters = { flagHabilitado: "Sim" };
        }

        serviceClienteInstalacao
            .getWithFilter({
                ...filters,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                setData(result?.data.content);
                setRowCount(result?.data.numberOfElements);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const onTableEdit = (data: any) => {
        serviceClienteInstalacao
            .update(data)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    onSuccessAction();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            });
    };

    useEffect(
        () => {
            if (props && props.location && props.location.state) {
                getAllWithFilters(props.location.state);
            } else {
                getAllWithFilters(filters);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    const onSubmit = (values: any) => {
        const newFilters = {
            ...values,
            flagHabilitado: values.flagHabilitado === "Todos" ? "" : values.flagHabilitado,
            devolucaoImpostos: values.devolucaoImpostos === "Todos" ? "" : values.devolucaoImpostos,
            travaFatura: values.travaFatura === "Todos" ? "" : values.travaFatura,
            regraDataVencimento: values.regraDataVencimento || "",
            formaDePagamento: values.formaDePagamento || "",
        };
        setFilters(newFilters);
        getAllWithFilters(newFilters);
    };

    useEffect(() => {
        if (props && props.location && props.location.state) {
            reset(props.location.state);
            setFilters(props.location.state);
            getAllWithFilters(props.location.state);
            setShowBackOptions(true);
        }
    }, [props]);

    const onClickInfo = (clienteInstalacaoID: any, numeroInstalacao: any) => {
        history.push({
            pathname: "/usinas/revisaoinstalacao",
            state: { clienteInstalacaoID: clienteInstalacaoID, numeroInstalacao: numeroInstalacao },
        });
    };

    const onClear = () => {
        reset({ clienteID: "", nomeCliente: "", regraDataVencimento: "", formaDePagamento: "" });
        setFilters(null);
        getAllWithFilters(null);
        setShowBackOptions(false);
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            {showBackOptions && rotaAnterior && (
                                <Grid container spacing={2} display="flex" alignItems="left">
                                    <Grid item md={2}>
                                        <Button
                                            id="voltar"
                                            disableElevation
                                            variant="text"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<ArrowBack />}
                                            onClick={() => {
                                                history.push(rotaAnterior, {
                                                    ...filterOld,
                                                });
                                            }}
                                        >
                                            Voltar
                                        </Button>
                                    </Grid>
                                    <Grid item md={10}>
                                        <Divider>
                                            {filterOld.codigoExternoCliente && (
                                                <div className="subTitle">{`Código Externo: ${filterOld.codigoExternoCliente}.`}</div>
                                            )}
                                        </Divider>
                                    </Grid>
                                </Grid>
                            )}

                            <Grid container spacing={2} display="flex" alignItems="center">
                                <Grid item xs={12} md={2}>
                                    <TextInput
                                        id="nomeCliente"
                                        name="nomeCliente"
                                        label="Nome cliente"
                                        control={control}
                                        error={errors}
                                        maxLength={200}
                                    />
                                </Grid>

                                <Grid item xs={12} md={2}>
                                    <AutoComplete
                                        id="concessionariaID"
                                        name="concessionariaID"
                                        label="Concessionaria"
                                        options={concessionariaDataOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <AutoComplete
                                        id="devolucaoImpostos"
                                        name="devolucaoImpostos"
                                        label="Dev. De Impostos"
                                        options={filtersOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <AutoComplete
                                        id="formaDePagamento"
                                        name="formaDePagamento"
                                        label="Forma de Pagamento"
                                        options={formaPagamentoOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <Button
                                        id="pesquisar"
                                        style={{ marginTop: 16, marginBottom: 8 }}
                                        variant="contained"
                                        color="warning"
                                        startIcon={<Search />}
                                        disableElevation
                                        type="submit"
                                        disabled={isLoading}
                                        fullWidth
                                        size="medium"
                                    >
                                        Pesquisar
                                    </Button>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <Button
                                        id="sincronizar"
                                        style={{ marginTop: 16, marginBottom: 8 }}
                                        variant="contained"
                                        color="primary"
                                        startIcon={<Cached />}
                                        onClick={handleSync}
                                        disableElevation
                                        fullWidth
                                        size="medium"
                                    >
                                        Sincronizar
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} display="flex" alignItems="center">
                                <Grid item xs={12} md={2}>
                                    <InputDocumento
                                        id="numeroDocumentoCliente"
                                        name="numeroDocumentoCliente"
                                        label="Documento"
                                        control={control}
                                        error={errors}
                                        maxLength={20}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <InputNumber
                                        id="numeroInstalacao"
                                        name="numeroInstalacao"
                                        label="Instalação"
                                        control={control}
                                        error={errors}
                                        decimalScale={0}
                                        noThousandSeparator
                                        maxLength={15}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <AutoComplete
                                        id="flagHabilitado"
                                        name="flagHabilitado"
                                        label="Habilitado"
                                        options={filtersOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <AutoComplete
                                        id="travaFatura"
                                        name="travaFatura"
                                        label="Trava de Fat."
                                        options={filtersOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <AutoComplete
                                        id="regraDataVencimento"
                                        name="regraDataVencimento"
                                        label="Regra Data de Vencimento"
                                        options={regraDataVencimentoOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <Button
                                        id="limpar"
                                        style={{ marginTop: 16, marginBottom: 8 }}
                                        variant="outlined"
                                        color="warning"
                                        startIcon={<Clear />}
                                        onClick={() => onClear()}
                                        disableElevation
                                        fullWidth
                                        size="medium"
                                    >
                                        Limpar
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.clienteInstalacaoID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>

                    <DialogSync open={showModal} onClose={() => setShowModal(false)} />

                    <DialogEdit
                        open={editState.open}
                        onSuccess={() => onSuccessAction()}
                        data={{
                            open: editState.open,
                            id: editState.id,
                            nomeCliente: editState.nomeCliente,
                            numeroInstalacao: editState.numeroInstalacao,
                            regraSaldoReenergisa: editState.regraSaldoReenergisa,
                            percentualDescontoContratado: editState.percentualDescontoContratado,
                            percentualDescontoFaturado: editState.percentualDescontoFaturado,
                            flagHabilitado: editState.flagHabilitado,
                            regraDataVencimento: editState.regraDataVencimento,
                            dataFixa: editState.dataFixa,
                        }}
                        onClose={() => {
                            setEditState({
                                open: false,
                                id: "",
                                nomeCliente: "",
                                numeroInstalacao: "",
                                regraSaldoReenergisa: "",
                                percentualDescontoContratado: "",
                                percentualDescontoFaturado: "",
                                flagHabilitado: "",
                                regraDataVencimento: "",
                                dataFixa: null,
                            });
                        }}
                    />
                    <ConfirmationDialog
                        open={dialogState}
                        title={"Devolução de Impostos"}
                        message={messages.confirmTableEditDevolucao}
                        cancelButtonText={"Não"}
                        confirmButtonText={"Sim"}
                        onClose={() => {
                            setTableEditState({});
                            setDialogState(false);
                        }}
                        onCancel={() => {
                            setTableEditState({});
                            setDialogState(false);
                        }}
                        onConfirm={() => {
                            onTableEdit(tableEditState);
                            setDialogState(false);
                        }}
                    />

                    <DialogTravaFatura
                        open={dialogTravaFaturaState}
                        travaFaturaState={tableEditTravaFaturaState}
                        onClose={() => {
                            setTableTravaFaturaEditState({});
                            setDialogTravaFaturaState(false);
                        }}
                        onSuccess={() => onSuccessAction()}
                    />
                    <ConfirmationDialog
                        open={dialogRegraDataConfirmState}
                        title={"Regra de vencimento"}
                        message={messages.confirmTableEditRegraDataVencimento}
                        cancelButtonText={"Não"}
                        confirmButtonText={"Sim"}
                        onClose={closeRegraDataConfirmDialog}
                        onCancel={closeRegraDataConfirmDialog}
                        onConfirm={handleConfirmRegraDataVencimento}
                    />
                    <DialogRegraDataVencimento
                        open={dialogRegraDataVencimentoState}
                        regraDataVencimentoState={tableRegraDataVencimentoState}
                        onClose={() => {
                            setTableRegraDataVencimentoState({});
                            setDialogRegraDataVencimentoState(false);
                        }}
                        onSuccess={() => onSuccessAction()}
                    />
                    <DialogDelete
                        open={deleteState.open}
                        data={{
                            id: deleteState.id,
                            open: deleteState.open,
                            numeroInstalacao: deleteState.numeroInstalacao,
                            nomeCliente: deleteState.nomeCliente,
                            clienteID: deleteState.clienteID,
                        }
                        }
                        onClose={() => {
                            setDeleteState({
                                open: false,
                                id: "",
                                numeroInstalacao: "",
                                nomeCliente: "",
                                clienteID: "",


                            });
                        }}
                        onSuccess={() => onSuccessAction()}

                    />

                </CardContent>
            </Card>
        </Container>
    );
};

export default ClienteInstalacao;
